// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2II0h","location":"Header_location__3x5a0"};